export enum Gender {
  male,
  female,
  other,
  not_specified
}



// WEBPACK FOOTER //
// ./src/app/models/Gender.ts